import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const getAll = "marcom/whatsapp/getAllTemplate";
const createtemplate = "marcom/whatsapp/addTemplate";
const getwhatsAppConfig = "marcom/whatsapp/getwhatsAppConfig";
const createwhatsAppConfig = "marcom/whatsapp/createwhatsAppConfig";
const create = "marcom/whatsapp/create";

export default {
  create(payload) {
    return Repository.post(`${create}`, payload);
  },
  getAllTemplate(payload) {
    return Repository.post(`${getAll}`, payload);
  },
  getwhatsAppConfig(payload) {
    return Repository.post(`${getwhatsAppConfig}`, payload);
  },
  createTemplate(payload) {
    return Repository.post(`${createtemplate}`, payload);
  },
  createwhatsAppConfig(payload) {
    return Repository.post(`${createwhatsAppConfig}`, payload);
  },
};
